var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-button',{attrs:{"color":"brand-blue","size":"large"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('document-download-icon',{staticClass:"mr-2"}),_vm._v(" Descargar PDF ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }